module.exports = __webpack_public_path__ + "static/hero-partial-screen-d7a1822190f0e79d6a4f4839e27d5408.svg";